import axios from 'axios'
import {API_BASE, META_API_BASE} from '../config'

import {
  ALL_FILES,
  ALL_FILES_SUCCESS,
  SIGNED_URL_FOR_UPLOAD,
  SIGNED_URL_FOR_UPLOAD_SUCCESS,
  SIGNED_URL_FOR_DOWNLOAD,
  SIGNED_URL_FOR_DOWNLOAD_SUCCESS,
  GET_USER_DETAILS,
  GET_USER_DETAILS_SUCCESS,
  GET_USER_TASK_DECISION_FLAG,
  GET_USER_TASK_DECISION_FLAG_SUCCESS,
  DROPZONE_CONFIG,
  DROPZONE_CONFIG_SUCCESS,
  NOTIFY,
  NOTIFY_SUCCESS,
  META_NOTIFY,
  META_NOTIFY_SUCCESS
} from './mutation-types'

export const productActions = {
  allFiles ({commit}, payload) {
    commit(ALL_FILES)
    return new Promise(function (resolve, reject) {
      axios.post(`${API_BASE}/getDropzoneFiles`, payload).then(function (response) {
        commit(ALL_FILES_SUCCESS, response.data)
        resolve(response)
      },
      function (error) {
        reject(error)
      })
    })
  },
  signedUrlForUpload ({commit}, payload) {
    commit(SIGNED_URL_FOR_UPLOAD)
    return new Promise(function (resolve, reject) {
      axios.post(`${API_BASE}/getSignedUrlForUpload`, payload).then(function (response) {
        commit(SIGNED_URL_FOR_UPLOAD_SUCCESS, response.data)
        resolve(response)
      },
      function (error) {
        reject(error)
      })
    })
  },
  signedUrlForDownload ({commit}, payload) {
    commit(SIGNED_URL_FOR_DOWNLOAD)
    return new Promise(function (resolve, reject) {
      axios.post(`${API_BASE}/fileDownloadFromS3Path`, payload).then(function (response) {
        commit(SIGNED_URL_FOR_DOWNLOAD_SUCCESS, response.data)
        resolve(response)
      },
      function (error) {
        reject(error)
      })
    })
  },
  getUserDetails ({commit}, payload) {
    commit(GET_USER_DETAILS)
    commit(GET_USER_DETAILS_SUCCESS, payload)
  },
  getUserTaskDecision ({commit}, payload) {
    commit(GET_USER_TASK_DECISION_FLAG)
    commit(GET_USER_TASK_DECISION_FLAG_SUCCESS, payload)
  },
  dropzoneConfig ({commit}, payload) {
    commit(DROPZONE_CONFIG)
    return new Promise(function (resolve, reject) {
      axios.get(`${API_BASE}/getDropzoneConfig/${payload}`, payload).then(function (response) {
        commit(DROPZONE_CONFIG_SUCCESS, response.data)
        resolve(response)
      },
      function (error) {
        reject(error)
      })
    })
  },
  notify ({commit}, payload) {
    commit(NOTIFY)
    return new Promise(function (resolve, reject) {
      axios.post(`${API_BASE}/notify`, payload).then(function (response) {
        commit(NOTIFY_SUCCESS, response.data)
        resolve(response)
      },
      function (error) {
        reject(error)
      })
    })
  },
  updateAcceptFlagFromDropzone ({commit}, payload) {
    // commit(NOTIFY)
    return new Promise(function (resolve, reject) {
      axios.post(`${API_BASE}/updateAcceptFlagFromDropzone`, payload).then(function (response) {
        // commit(NOTIFY_SUCCESS, response.data)
        resolve(response)
      },
      function (error) {
        reject(error)
      })
    })
  },
  updateMetadata ({commit}, payload) {
    commit(META_NOTIFY)
    return new Promise(function (resolve, reject) {
      axios.post(`${META_API_BASE}/setArticleJobflowProperties/${payload.metadataid}/${payload.articlejobflowmetadataid}`, payload).then(function (response) {
        commit(META_NOTIFY_SUCCESS, response.data)
        resolve(response)
      },
      function (error) {
        reject(error)
      })
    })
  }

}



// WEBPACK FOOTER //
// ./src/store/actions.js